/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkflowsResponseDto } from '../../models/workflows-response-dto';

export interface ClientGetActiveWorkflowsFromHyperScienceGet$Plain$Params {
}

export function clientGetActiveWorkflowsFromHyperScienceGet$Plain(http: HttpClient, rootUrl: string, params?: ClientGetActiveWorkflowsFromHyperScienceGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkflowsResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, clientGetActiveWorkflowsFromHyperScienceGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WorkflowsResponseDto>>;
    })
  );
}

clientGetActiveWorkflowsFromHyperScienceGet$Plain.PATH = '/Client/GetActiveWorkflowsFromHyperScience';
